import React from 'react';
import PropTypes from 'prop-types';

import { ListItem as MUIListItem } from '@material-ui/core';

export const ListItem = props => <MUIListItem {...props} />;

ListItem.propTypes = {
  alignItems: PropTypes.oneOf(['flex-start', 'center']),
  button: PropTypes.bool,
  classes: PropTypes.object,
  component: PropTypes.elementType,
  dense: PropTypes.bool,
  disableGutters: PropTypes.bool,
  disabled: PropTypes.bool,
  divider: PropTypes.bool,
  selected: PropTypes.bool
};

export default ListItem;
